import { FC, useMemo } from 'react';
import { ButtonSquare, Dropdown, Icon, Tooltip } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { foldersModel } from '../../../features/folders';

import { useSelector } from 'react-redux';
import { useFolderPermissions } from '../../../features/folders';
import { teamsModel } from '../../../features/teams';

type Props = {
  onRenameFolder: () => void;
  onDeleteFolder: () => void;
  onShareFolder: () => void;
};

export const WorkspaceFolderAction: FC<Props> = ({
  onRenameFolder,
  onDeleteFolder,
  onShareFolder,
}) => {
  const currentFolder = useSelector(
    foldersModel.selectors.selectCurrentFolderWithError
  );
  const folderPermissions = useFolderPermissions(currentFolder);

  const teamUsers = useSelector(teamsModel.selectors.selectCurrentTeamMembers);
  const teamUsersInviteAccepted = useMemo(
    () => teamUsers.filter((user) => !user.isWaitingForInviteAcceptance),
    [teamUsers]
  );

  const folderOptions = [
    {
      id: 'Rename',
      label: 'Rename',
      onClick: onRenameFolder,
      iconName: IconMap.TextInput,
      iconWidth: 16,
      isShow: folderPermissions.isCanRename,
    },
    {
      id: 'Delete',
      label: 'Delete',
      onClick: onDeleteFolder,
      iconName: IconMap.Delete,
      iconWidth: 16,
      isShow: folderPermissions.isCanDelete,
    },
  ].filter((i) => i.isShow);

  if (folderOptions.length === 0) {
    return null;
  }

  const isShowShare =
    teamUsersInviteAccepted?.length > 1 && folderPermissions.isCanManageAccess;

  return (
    <div className="mr-auto md:hidden flex flex-nowrap gap-x-3 items-center">
      {isShowShare && (
        <button
          type="button"
          className="md:hidden flex flex-nowrap items-center gap-x-1 h-10 px-3.5 rounded-lg text-md font-semibold text-gray-600 hover:text-gray-700 hover:bg-base-black/[0.08]"
          onClick={onShareFolder}
        >
          <Icon glyph={IconMap.Share07} width={20} className="text-gray-700" />
          Share
        </button>
      )}
      {folderOptions.length > 1 && (
        <Tooltip
          trigger={
            <Dropdown
              align="start"
              listStyles="shadow-lg"
              triggerComponent={
                <DropdownMenu.Trigger className="md:hidden focus:outline-none">
                  <ButtonSquare size="md" variant="tertiary-gray">
                    <Icon glyph={IconMap.DotsHorizontal} width={20} />
                  </ButtonSquare>
                </DropdownMenu.Trigger>
              }
              items={folderOptions}
            />
          }
          hideArrow
          className="font-semibold px-3 py-2"
          sideOffset={4}
        >
          Actions
        </Tooltip>
      )}
    </div>
  );
};
